import {
  AHB_MESSAGE_TYPE,
  AHB_PROCEDURE_ID,
  AHB_SUBPROCEDURE,
  AHB_VERSION,
  AHB_WITHDRAW_REASON,
} from "core/consts";
import { z } from "zod";
import {
  ahbDateinummerSchema,
  AHBdateSchema,
  AHBtimeSchema,
  IKNumberSchema,
} from "./shared";

export const AHBWithdrawalSchema = z.object({
  Nutzdaten: z.object({
    "@xmlns": z.string(),
    "@xmlns:aar": z.string(),
    "@xmlns:arh": z.string(),
    "@xmlns:feh": z.string(),
    "@xmlns:gdb": z.string(),
    "@xmlns:sto": z.string(),

    Body: z.object({
      Stornonachricht: z.object({
        "sto:Begruendung": z
          .object({
            "sto:Erlaeuterung": z.string().max(600).optional().nullable(),
            "sto:Grund": z.nativeEnum(AHB_WITHDRAW_REASON),
          })
          .superRefine((data, ctx) => {
            if (data["sto:Grund"] === AHB_WITHDRAW_REASON.OTHER) {
              if (
                !data["sto:Erlaeuterung"] ||
                data["sto:Erlaeuterung"].trim() === ""
              ) {
                ctx.addIssue({
                  code: z.ZodIssueCode.custom,
                  message:
                    'Erläuterung is required when Grund is "9 - Sonstiges".',
                  path: ["sto:Erlaeuterung"],
                });
              }
            }
          }),
        "sto:Datei_ID": z.uuid(),
      }),
    }),

    Header: z.object({
      "gdb:Absender": z.object({
        "gdb:Krankenhaus": z.object({
          "gdb:Institutionskennzeichen": IKNumberSchema,
        }),
      }),
      "gdb:Datei_ID": z.uuid(),
      "gdb:Empfaenger": z.object({
        "gdb:Krankenkasse": z.object({
          "gdb:Institutionskennzeichen": IKNumberSchema,
        }),
      }),
      "gdb:Erstellungsdatum": AHBdateSchema,
      "gdb:Erstellungszeit": AHBtimeSchema,
      "gdb:Logische_Version": z.nativeEnum(AHB_VERSION),
      "gdb:Nachrichtentyp": z.literal(AHB_MESSAGE_TYPE.WITHDRAWAL),
      "gdb:Unterverfahren": z.literal(AHB_SUBPROCEDURE),
      "gdb:Verfahrenskennung": z.nativeEnum(AHB_PROCEDURE_ID),
      "gdb:Dateinummer": ahbDateinummerSchema,
    }),
  }),
});
